import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../store/app";
import { fetchTrainingCertificate } from "../Utils/slice";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { TrainingCredentialBreadcrumb } from "../../../../../config/BreadcrumbConfig";
import { Col, Row, Skeleton } from "antd";

const TrainingCredentials = () => {
  const dispatch: AppDispatch = useDispatch();
  const credentialsData = useSelector(
    (state: RootState) => state.WEBPROFILE.trainingCertificateList
  );
  const loading = useSelector(
    (state: RootState) => state.WEBPROFILE.appLoading
  );

  useEffect(() => {
    dispatch(fetchTrainingCertificate());
  }, [dispatch]);

  return (
    <div style={{ background: "#f5f6f7" }} className="all-careers-mobile">
      <section>
        <div className="container-fluid">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="career-index-header mobile-header">
                <BreadcrumbComponent
                  key={1}
                  items={TrainingCredentialBreadcrumb.path}
                />
                <div
                  style={{
                    fontSize: 17,
                    color: "#555",
                    marginLeft: 5,
                    marginTop: 10,
                  }}
                >
                  Lorem ipsum dolor sit amet consectetur. Dictumst diam risus
                  leo suspendisse phasellus cras sit phasellus sit. Nec
                  tincidunt mattis cursus tristique. Cras cum aliquam eget ut in
                  lacus tempor. Purus id facilisis in bibendum morbi urna
                  nisi...
                </div>
              </div>
            </Col>

            <Col span={24}>
              <div className="training-credentials-section">
                <div
                  style={{ fontWeight: 500, fontSize: 24, marginLeft: 10 }}
                  className="training-credentials-section-title"
                >
                  Licensing and Certifications
                </div>
                <div className="training-credentials-cards">
                  {loading ? (
                    <Skeleton avatar paragraph={{ rows: 1 }} active />
                  ) : (
                    credentialsData?.map((card: any) => (
                      <div
                        className="training-credentials-card"
                        key={card.title}
                        style={{ marginLeft: 10, marginRight: 10 }}
                      >
                        <div className="training-credentials-card-title">
                          {card.name}
                        </div>
                        {card.description && (
                          <div
                            className="training-credentials-card-desc"
                            dangerouslySetInnerHTML={{
                              __html: card.description,
                            }}
                          ></div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default TrainingCredentials;
